import React from 'react';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const IMG = {
  hero: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?q=80&w=2653&auto=format&fit=crop',
  heroGrid1: 'https://images.pexels.com/photos/4483323/pexels-photo-4483323.jpeg?auto=compress&cs=tinysrgb&w=800',
  heroGrid2: 'https://images.pexels.com/photos/7584492/pexels-photo-7584492.jpeg?auto=compress&cs=tinysrgb&w=800',
  heroGrid3: 'https://images.pexels.com/photos/4021766/pexels-photo-4021766.jpeg?auto=compress&cs=tinysrgb&w=800',
  heroGrid4: 'https://images.pexels.com/photos/5206949/pexels-photo-5206949.jpeg?auto=compress&cs=tinysrgb&w=800',
};

const HomeHero: React.FC = () => (
  <section className="bg-hero-gradient min-h-[100vh] min-h-[100dvh] overflow-hidden relative flex flex-col">
    <div className="absolute inset-0">
      <img src={IMG.hero} alt="Hospital corridor" className="w-full h-full object-cover opacity-30 mix-blend-overlay" />
      <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/95 to-primary/60" />
    </div>

    <div className="relative z-10 flex-1 flex flex-col justify-end pt-20 pb-6 sm:pb-8 lg:pb-1">
      <div className="container-main grid lg:grid-cols-2 gap-8 sm:gap-12 items-end">
        <div className="min-w-0">
          <span className="inline-block bg-white/10 border border-white/20 text-white/80 text-xs font-semibold px-3 py-1.5 sm:px-4 rounded-full mb-3 sm:mb-4 uppercase tracking-widest">
            Zimbabwe's Leading Medical Supplier
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-4 sm:mb-6">
            Medical Supplies &amp;<br />Equipment,<br />
            <span className="text-white/70">Delivered Across Africa</span>
          </h1>
          <p className="text-white/70 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8 max-w-lg">
            CE Certified · FDA Approved · 3,000+ products for hospitals and laboratories
            at highly competitive prices.
          </p>
          <div className="flex flex-wrap gap-3 sm:gap-4">
            <Link to="/contact" className="btn-primary text-sm sm:text-base px-6 py-3.5 sm:px-8 sm:py-4 min-h-[44px] inline-flex items-center justify-center">
              Get A Quote <ArrowForwardIcon />
            </Link>
            <Link to="/shop" className="inline-flex items-center justify-center gap-2 border border-white/40 text-white px-6 py-3.5 sm:px-8 sm:py-4 rounded-full font-semibold text-sm sm:text-base hover:bg-white/10 transition-colors min-h-[44px]">
              Browse Products <ArrowForwardIcon />
            </Link>
          </div>
        </div>

        <div className="hidden lg:grid grid-cols-2 gap-5 pb-0 mt-[10px]">
          <div className="space-y-5">
            <div className="rounded-2xl overflow-hidden shadow-2xl h-[15.4rem] bg-white/10">
              <img src={IMG.heroGrid1} alt="Medical team in hospital" className="w-full h-full object-cover" />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-2xl h-[12rem] bg-white/10">
              <img src={IMG.heroGrid2} alt="Doctor with patient" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="space-y-5 mt-10">
            <div className="rounded-2xl overflow-hidden shadow-2xl h-[12rem] bg-white/10">
              <img src={IMG.heroGrid3} alt="Hospital care" className="w-full h-full object-cover" />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-2xl h-[15.4rem] bg-white/10">
              <img src={IMG.heroGrid4} alt="Medical equipment" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HomeHero;
